// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partners-about-section-container {
  flex-wrap: wrap !important;
}

@media (min-width: 768px) {
  .partners-about-section-wells {
    width: 100%;
  }
}

@media (min-width: 1024px) {
  .partners-about-section-wells {
    width: 30%;
  }
}

@media (min-width: 1440px) {
  .partners-about-section-wells {
    width: 31.8%;
  }
}

.partners-about-section-boxes {
  /* width: 31.3%; */
  padding: 0 24px;
}

.partnerTextName .mds-header-branding-name a {
  color: #373c42 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/login-page-about-section/login-page-about-section.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".partners-about-section-container {\n  flex-wrap: wrap !important;\n}\n\n@media (min-width: 768px) {\n  .partners-about-section-wells {\n    width: 100%;\n  }\n}\n\n@media (min-width: 1024px) {\n  .partners-about-section-wells {\n    width: 30%;\n  }\n}\n\n@media (min-width: 1440px) {\n  .partners-about-section-wells {\n    width: 31.8%;\n  }\n}\n\n.partners-about-section-boxes {\n  /* width: 31.3%; */\n  padding: 0 24px;\n}\n\n.partnerTextName .mds-header-branding-name a {\n  color: #373c42 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
